<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: Language bar -->
    <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
        ref="notificationDropdown"
      >
        <template v-slot:button-content>
          <img
            class="rounded-sm pulse"
            :src="notificationIcon"
            alt=""
          />
          <span v-if="count"
                class="alert-danger btn-sm font-weight-bold btn-font-md position-absolute alert-badge"
          >
          {{ count }}
        </span>
        </template>
        <b-dropdown-text tag="div" class="w-100 min-w-md-350px">
          <DropdownNotification
              v-on:notification-clicked="onNotificationClicked"
          />
        </b-dropdown-text>
      </b-dropdown>
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
        ref="dropdownNotification"
      >
        <template v-slot:button-content>
          <img
            class="h-20px w-20px rounded-sm"
            :src="languageFlag || getLanguageFlag"
            alt=""
          />
        </template>
        <b-dropdown-text tag="div" class="min-w-md-175px">
          <KTDropdownLanguage
            v-on:language-changed="onLanguageChanged"
          ></KTDropdownLanguage>
        </b-dropdown-text>
      </b-dropdown>
    </div>
    <!--end: Language bar -->

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }
  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import DropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";
import baseModule, {
  COUNT,
  MODULE_NAME as BASE_MODULE,
  GET_COUNT, ERROR
} from "@/core/services/store/notification.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

export default {
  name: "KTTopbar",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_BASE_MODULE, baseModule);
  },
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages
    };
  },
  components: {
    KTDropdownLanguage,
    DropdownNotification,
    KTQuickUser
  },
  methods: {
    onNotificationClicked(item) {
      this.$refs.notificationDropdown.hide();
      this.getNotificationCount();
      if (item && item.route) {
        this.$router.push(item.route);
      }
    },
    getNotificationCount() {
      this.$store.dispatch(_BASE_MODULE + '/' + GET_COUNT, {});
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    }
  },
  computed: {
    count() {
      let countData =  store.getters[_BASE_MODULE + "/" + COUNT];

      if (countData && countData.hasOwnProperty('count')) {
        return countData.count;
      }

      return 0;
    },
    notificationIcon() {
      return process.env.BASE_URL + "media/svg/icons/Code/Compiling.svg";
    },
    notificationCount() {
      let countData =  store.getters[_BASE_MODULE + "/" + COUNT];

      if (countData && countData.hasOwnProperty('count')) {
        return countData.count;
      }

      return 0;
    },
    getLanguageFlag() {
      return this.onLanguageChanged();
    }
  },
  mounted() {
    this.getNotificationCount();
  }
};
</script>

<style scoped>
.alert-badge {
  border-radius: 50%;
  top: -5px;
  right: -10px;
  padding: 4px 10px;
}
</style>
